import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Techstack from "./Techstack";
import Certifications from "./Certifications";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/about.png";
import Toolstack from "./Toolstack";

function About() {
  return (
    <>
      {" "}
      <Particle />
      <Container fluid className="about-section">
        <Container>
          <Row style={{ justifyContent: "center", padding: "10px" }}>
            <Col
              md={7}
              style={{
                justifyContent: "center",
                paddingTop: "30px",
                paddingBottom: "50px",
              }}
            >
              <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
                <strong className="teal">Who am I?</strong>
              </h1>
              <Aboutcard />
            </Col>
            <Col
              md={5}
              style={{ paddingTop: "120px", paddingBottom: "50px" }}
              className="about-img"
            >
              <img src={laptopImg} alt="about" className="img-fluid" />
            </Col>
          </Row>

          {/* ----------------- SKILLS SECTION ----------------- */}
          <Container className="px-5 py-4">
            <h1 className="project-heading">
              Professional <strong className="teal">Skills</strong>
            </h1>
            <Techstack />
          </Container>

          {/* ----- TOOLS SECTION ----- */}
          <Container className="px-5 py-4">
            <h1 className="project-heading">
              <strong className="teal">Tools</strong> Used
            </h1>
            <Toolstack />
          </Container>

          {/* ----- CERTIFICATIONS SECTION ----- */}
          <Container className="px-5 py-4">
            <h1 className="project-heading">
              My <strong className="teal">Certifications</strong>
            </h1>
            <Certifications />
          </Container>



        </Container>
      </Container>
    </>
  );
}

export default About;
